<template>
    <!-- 宏观分析 -->
    <div class="analysis">
        <div class="row-four clearfix">
            <span class="fl">宏观分析观点</span>
            <el-button type="built" class="fr" @click="dialogTableVisible=true"><i class="el-icon-plus"></i>新建观点</el-button>
        </div>
        <el-table class="table-two mt30" :data="viewTable" border>
            <el-table-column type="index"></el-table-column>
            <el-table-column property="title" label="名称"></el-table-column>
            <el-table-column property="dealDate" label="创建日期"></el-table-column>
            <el-table-column property="userName" label="创建者"></el-table-column>
            <el-table-column property="operate" label="操作">
                <template slot-scope="scope">
                    <span class="btn-normal" @click="delShare(scope.row)"><i class="el-icon-delete table-single-icon"></i>删除</span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新建观点 -->
        <el-dialog title="新建观点" class="dialog-normal" :visible.sync="dialogTableVisible" @close="dialogReset">
            <div class="point" id="scrollbox">
                <el-form class="form-info" ref="addFormRef" :model="addForm" :inline="true" label-position="right">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="addForm.name" style="width:580px;"></el-input>
                    </el-form-item>   
                    <el-form-item label="日期" prop="date" style="margin-left: 92px;">
                        <el-date-picker type="month" class="date-picker-one" style="width: 115px;" v-model="addForm.date" :editable="false" placeholder="选择日期" :clearable="false" value-format="yyyy-MM"></el-date-picker>
                    </el-form-item>
                    <br>
                    <el-form-item label="是否公开观点：" prop="publicStatus">
                        <el-radio v-model="addForm.publicStatus" :label="1">是</el-radio>
                        <el-radio v-model="addForm.publicStatus" :label="0">否</el-radio>
                    </el-form-item>
                </el-form>
                <div v-for="(item,i) in tabLists" :key="i+'tab'">
                    <el-tabs v-model="item.activeName" type="card" :class="[{'mt10':i!=0},'dialog-normal-tabs']">
                        <el-tab-pane name="first" :disabled="item.fileList.length != 0">
                            <span slot="label"><img src="../../assets/images/text.png" style="vertical-align: text-bottom;"> 文本</span>
                            <el-input type="textarea" v-model="item.pointText" placeholder="请输入文本..." :rows="8" resize="none"></el-input>
                        </el-tab-pane>
                        <el-tab-pane name="second" :disabled="item.pointText!=''">
                            <span slot="label"><i class="el-icon-picture-outline"></i> 图片</span>
                            <el-upload class="upload-normal" action list-type="picture-card" :file-list="item.fileList" :on-change="(file, fileList) => {onChangeFile(file, fileList, i)}" :on-remove="(file, fileList) => {handleRemove(file, fileList, i)}" :auto-upload="false">
                                <img src="../../assets/images/uplod.png" alt="">
                            </el-upload>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div slot="footer" class="point-footer">
                <el-button type="normal" @click="moduleAdd">添加模块</el-button>
                <el-button type="normal" @click="preserve">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            viewTable: [],
            dialogTableVisible: false,
            addForm: {
                name: '',
                date: '',
                publicStatus: 1,
            },
            tabLists: [
                {
                    activeName: 'first',
                    pointText: '',
                    fileList: [],
                    imgInfo: {
                        Base64: '',
                        name: '',
                    },
                },
            ]
        }
    },
    mounted() {
        this.getMacroViewList()
    },
    methods: {
        // 观点列表
        getMacroViewList() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetMacroViewList,{
                UserCode: vm.$commonJs.getCookie('userCode'),
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    vm.viewTable = res.data.data.dataList
                }
            }).catch(err=>{})
        },
        moduleAdd() {
            this.tabLists.push({
                activeName: 'first',
                pointText: '',
                fileList: [],
                imgInfo: {
                    Base64: '',
                    name: '',
                },
            })
            this.$nextTick(() => {
                let box = document.getElementById('scrollbox');
                let height = this.tabLists.length * 283
                box.scrollTo({
                    top: height,
                    behavior:'smooth'
                })
            })
        },
        // 保存
        preserve() {
            let vm = this
            if(vm.addForm.name == '') {
                vm.$message.error('请填写名称')
            } else if(vm.addForm.date == '') {
                vm.$message.error('请选择日期')
            } else if(vm.tabLists[0].pointText == '' && vm.tabLists[0].fileList.length == 0) {
                vm.$message.error('请输入文本或上传图片')
            } else {
                let con = []
                vm.tabLists.forEach((item,i) => {
                    if(item.imgInfo.Base64 != '' || item.pointText != '') {
                        con.push({
                            ContentType: item.pointText==''? 1 : 0,//0文本，1图片
                            Name: item.pointText==''? item.imgInfo.name : '',//图片名称
                            Content: item.pointText==''? item.imgInfo.Base64: item.pointText,//内容
                        })
                    }
                })
                vm.$http.post(vm.$apiPath.AddedMacroView,{
                    UserCode: vm.$commonJs.getCookie('userCode'),
                    DealDate: vm.addForm.date,
                    Title: vm.addForm.name,//标题
                    PublicStatus: vm.addForm.publicStatus,//公开状态，1公开，0不公开
                    Contents: con,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200 && res.data.data.note) {
                        vm.$message.success('添加成功!')
                    } else {
                        vm.$message.error('添加失败!')
                    }
                    vm.dialogTableVisible = false
                    vm.getMacroViewList()
                    vm.dialogReset()
                }).catch(err=>{})
            }
        },
        // 删除观点
        delShare(scope) {
            let vm = this
            vm.$confirm('要删除“'+scope.title+'吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                vm.$http.post(vm.$apiPath.DeleteMacroView,{
                    ID: scope.id,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        vm.$message.success('删除成功!')
                    } else {
                        vm.$message.error('删除失败!')
                    }
                    vm.getMacroViewList()
                }).catch(err=>{})
                
            }).catch(err=>{})
        },
        // 文件改变
        onChangeFile (file,fileList,i) {
            let vm = this
            vm.tabLists[i].fileList.push(file)// 添加到数组
            vm.tabLists[i].fileList.forEach((item, i) => {
                item.index = i
            })
            if (vm.tabLists[i].fileList.length > 1) {
                vm.tabLists[i].fileList.splice(0, 1);
            }
            vm.tabLists[i].imgInfo.name = file.name
            vm.$commonJs.getBase64(file.raw).then(result => {
                vm.tabLists[i].imgInfo.Base64 =  result
            });
            return false
        },
        // 重置
        dialogReset() {
            this.$refs['addFormRef'].resetFields()
            this.dialogTableVisible = false
            this.tabLists = [{
                activeName: 'first',
                pointText: '',
                fileList: [],
                imgInfo: {
                    Base64: '',
                    name: '',
                },
            }]
        },
        // 删除图片或视频
        handleRemove (file,fileList,i) {
            const tPic = file.index;
            const index = this.tabLists[i].fileList.findIndex(item => item.index == tPic)
            this.tabLists[i].fileList.splice(index, 1)
        },
    }
}
</script>

<style lang="less" scoped>
.analysis {
    .el-table .btn-normal::before {display: none;}
    i {margin-right: 5px;}
    .dialog-normal {
        /deep/.el-dialog__body {padding: 0;}
        .point {
            overflow-y: scroll;padding: 30px 126px 0;height: 437px;box-sizing: border-box;
            .form-info {display: inline-block;}
            .el-textarea /deep/.el-textarea__inner {padding: 26px;border: none;font-size: 16px;}
            .upload-normal {
                padding: 26px;
                /deep/.el-upload-list__item,/deep/.el-upload--picture-card {width: 74px;height: 74px;line-height: 74px; border: none;}
            }
        }
    }
}
</style>